import WithPermissionRestricted from '../../../../general/hoc/WithPermissionRestricted'
import {PromotionsDashboardProvider} from './PromotionsDashboard'
import PromotionsDashboardLayout from './PromotionsDashboardLayout'

function PromotionsDashboardWrapper() {

  return (
    <PromotionsDashboardProvider>
      <PromotionsDashboardLayout />
    </PromotionsDashboardProvider>
  )
}

export default WithPermissionRestricted(PromotionsDashboardWrapper, 'FILTERS', [
  'promotions',
  'GetAllPromotions',
])